"use strict";

exports.__esModule = true;
exports.exportDataToCSVFormat = exportDataToCSVFormat;
exports.generateTemplateForObject = generateTemplateForObject;
exports.getValue = getValue;
var _humanizeString = require("./humanizeString");
var _getValueByString = require("./getValueByString");
/**
 * Given and object create a template for mapping the data to a rows and columns csv structure
 */
function generateTemplateForObject(target) {
  var template = {
    columns: {}
  };
  for (var _i = 0, _Object$keys = Object.keys(target); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    template.columns[key] = (0, _humanizeString.humanizeString)(key);
  }
  return template;
}
function getValue(itemData) {
  if (itemData === null) {
    return "";
  }
  if (itemData && itemData.props) {
    // assume we have a value in the child of a react node as this meets requirements for now
    return itemData.props.children;
  }

  // just return the value or force it to be a string if it's an object
  return typeof itemData === "object" ? "" + JSON.stringify(itemData) : "" + itemData;
}
function exportDataToCSVFormat(data, template) {
  if (data === void 0) {
    data = [];
  }
  if (!data || data.length === 0) {
    // empty
    return {
      headers: [],
      rows: []
    };
  }
  if (!template) {
    template = generateTemplateForObject(data[0]);
  }
  var keys = Object.keys(template.columns);
  var descriptions = Object.values(template.columns);
  return {
    headers: descriptions,
    rows: data.map(function (item) {
      return keys.map(function (key) {
        if (key.includes(".000Z")) {
          // Time columns generated by pivoting should be returned as is.
          return item[key];
        }
        var itemData = (0, _getValueByString.getValueByString)(item, key);
        if (template && template.formatter && template.formatter[key]) {
          // apply formatter to raw values
          return template.formatter[key](item, key);
        }
        if (Array.isArray(itemData)) {
          return "\"" + itemData.map(getValue).join(", ") + "\"";
        }
        return "\"" + getValue(itemData) + "\"";
      });
    })
  };
}